export const lifts_en = {
    "gondola": "Gondola",
    "chair_lift": "Chair-lift",
    "t-bar": "T-Bar",
    "magic_carpet": "Magic carpet",
    "rope_tow": "Rope tow",
    "cable_car": "Cable car",
    "rack_train": "Rack railway",
    "other": "Zipline"
}

export const lifts_de = {
    "gondola": "Gondola",
    "chair_lift": "Sessellift",
    "t-bar": "Schlepplift",
    "magic_carpet": "Magic carpet",
    "rope_tow": "Seillift",
    "cable_car": "Seilbahn",
    "rack_train": "Zahnradbahn",
    "other": "Zipline"
}

export const lifts_fr = {
    "gondola": "Télécabine",
    "chair_lift": "Télésiège",
    "t-bar": "Barre en T",
    "magic_carpet": "Tapis magique",
    "rope_tow": "Télécorde",
    "cable_car": "Téléphérique",
    "rack_train": "Chemin de fer à crémaillère",
    "other": "Tyrolienne"
}

export const lifts_it = {
    "gondola": "Gondola",
    "chair_lift": "Seggiovia",
    "t-bar": "T-Bar",
    "magic_carpet": "Magic carpet",
    "rope_tow": "Manovia",
    "cable_car": "Funivia",
    "rack_train": "Ferrovia con cremagliera",
    "other": "Zipline"
}

export const lifts_es = {
    "gondola": "Telecabina",
    "chair_lift": "Chair-lift",
    "t-bar": "Telearrastre",
    "magic_carpet": "Cinta transportadora",
    "rope_tow": "Telecuerda",
    "cable_car": "Teleférico",
    "rack_train": "Tren cremallera",
    "other": "Zipline"
}

export const lifts_nb = {
    "gondola": "Gondol",
    "chair_lift": "Stolheis",
    "t-bar": "T-krok",
    "magic_carpet": "Magisk teppe",
    "rope_tow": "Slepetau",
    "cable_car": "Gondol",
    "rack_train": "Tannstangbane",
    "other": "Zipline"
}